import React, { useState } from "react";
import {
  Modal,
  StyleSheet,
  View,
  TouchableOpacity,
  Image,
  Pressable,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import t from "@constants/localization";
import Close from "@assets/svg/CloseIcon";
import RadioSelected from "@assets/svg/RadioSelected";
import RadioUnselected from "@assets/svg/RadioUnselected";
import CustomText from "@components/CustomText";
import DashedLine from "@components/DashedLine";
import Ibutton from "@assets/svg/RRD/Ibutton";

const PATH = "screens/RRD/RescheduleModal";

const DeliveryInfoModal = ({
  visible = true,
  setVisible,
  onSubmit,
  info = {},
}) => {
  const [selected, setSelected] = useState(null);
  const insets = useSafeAreaInsets();

  const closeModal = () => {
    setVisible(false);
    setSelected(null);
  };

  const reschedule = () => {
    onSubmit(selected);
    closeModal();
  };

  return (
    <>
      <Modal
        transparent
        visible={visible}
        onRequestClose={closeModal}
        animationType="slide"
        statusBarTranslucent
        navigationBarTranslucent
      >
        <View style={styles.modalBackground}>
          <View style={styles.modalContainer}>
            <View style={{ alignItems: "center", paddingBottom: 16 }}>
              <View>
                <TouchableOpacity
                  onPress={() => {
                    closeModal();
                  }}
                  style={styles.cross}
                >
                  <Close
                    fill="rgba(255, 255, 255, 0.8)"
                    width="24"
                    height="24"
                  />
                </TouchableOpacity>
              </View>
            </View>
            <View
              style={{
                backgroundColor: "#fff",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                paddingBottom: insets.bottom,
              }}
            >
              <View style={styles.container}>
                <View style={styles.imageContainer}>
                  <Image
                    source={{
                      uri: info.icon,
                    }}
                    style={styles.icon}
                    resizeMode="cover"
                  />
                  <CustomText
                    variant="title_18_regular"
                    style={styles.headerHeadingText}
                  >
                    {info.heading}
                  </CustomText>
                  <View style={styles.headerHorozontalLine} />
                  <CustomText variant="body_text_3" style={styles.desc}>
                    {info.desc}
                  </CustomText>
                </View>
                <CustomText variant="body_text_1" style={styles.headingText}>
                  {info.question}
                </CustomText>
                <View style={styles.bodyContainer}>
                  <Ibutton
                    CircleColor="rgba(0, 0, 0, 0.8)"
                    IColor="white"
                    DotColor="white"
                    style={{ marginTop: 3 }}
                  />
                  <CustomText variant="body_text_3" style={styles.bodyText}>
                    {"  "}
                    {info.timeInfo}
                  </CustomText>
                </View>

                <DashedLine
                  axis="horizontal"
                  height="100"
                  width="400"
                  spacing="4"
                  dashHeight="1"
                  dashColor="rgba(0, 0, 0, 0.2)"
                  dashWidth="2"
                />
                <View style={{ marginTop: 8 }}>
                  {Array.isArray(info.reasons) &&
                    info.reasons.map((v, i) => (
                      <Pressable
                        key={i}
                        onPress={() => {
                          setSelected(v.key);
                        }}
                      >
                        {i > 0 && <View style={styles.horozontalLine} />}
                        <View
                          style={{
                            flexDirection: "row",
                            flexGrow: 1,
                            margin: 5,
                            alignItems: "center",
                            height: 40,
                          }}
                        >
                          <View style={{ marginRight: 13 }}>
                            {v.key === selected ? (
                              <RadioSelected />
                            ) : (
                              <RadioUnselected />
                            )}
                          </View>
                          <CustomText
                            style={{
                              color: "black",
                              textAlign: "center",
                              fontFamily: "NotoSansDevanagari-Regular",
                            }}
                          >
                            {v.value}
                          </CustomText>
                        </View>
                      </Pressable>
                    ))}
                </View>

                <TouchableOpacity
                  onPress={reschedule}
                  disabled={selected ? false : true}
                  style={{
                    borderRadius: 8,
                    alignItems: "center",
                    justifyContent: "center",
                    height: 48,
                    backgroundColor: selected
                      ? "rgba(228, 0, 70, 1)"
                      : "rgba(0, 0, 0, 0.1)",
                    marginVertical: 20,
                  }}
                >
                  <CustomText style={{ color: "white" }} variant="body_text_4">
                    {t(`${PATH}/submit`)}
                  </CustomText>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

export default DeliveryInfoModal;

const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContainer: {
    position: "absolute",
    bottom: 0,
  },
  icon: {
    height: 200,
    width: 200,
  },
  iconContainer: {
    left: 20,
    bottom: 90,
  },
  container: {
    position: "relative",
    // top: -32,
    margin: 12,
  },
  headerHeadingText: {
    color: "rgba(0, 0, 0, 0.86)",
    fontSize: 20,
    fontWeight: "700",
  },
  headingText: {
    color: "rgba(0, 0, 0, 0.86)",
    lineHeight: 22,
    fontWeight: "700",
    marginTop: 24,
  },
  bodyText: {
    color: "rgba(0, 0, 0, 0.86)",
  },
  bodyContainer: {
    marginTop: 8,
    marginBottom: 12,
    flexDirection: "row",
  },
  desc: {
    color: "rgba(0, 0, 0, 0.86)",
    marginVertical: 12,
    paddingHorizontal: 23,
    textAlign: "center",
  },
  cross: {
    height: 32,
    width: 32,
    borderRadius: 16,
    backgroundColor: "rgba(51, 51, 51, 1)",
    padding: 4,
  },
  horozontalLine: {
    borderWidth: 0.5,
    borderColor: "black",
    opacity: 0.1,
  },
  headerHorozontalLine: {
    marginTop: 8,
    width: 20,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.2)",
  },
  imageContainer: {
    backgroundColor: "rgba(255, 236, 145, 1)",
    borderRadius: 10,
    flexDirection: "column",
    alignItems: "center",
  },
});
